__turbopack_context__.v({
  "item": "UndeletableAssetsList-module__Utnoaq__item",
  "list": "UndeletableAssetsList-module__Utnoaq__list",
});
